import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-titles',
  templateUrl: './edit-titles.component.html',
  styleUrls: ['./edit-titles.component.scss']
})
export class EditTitlesComponent implements OnInit {
  @Input() titleData: any;
  orderOpts: any;

  constructor(
    private activeModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.orderOpts = this.titleData.id ? new Array(this.titleData.all.length) : new Array(this.titleData.all.length + 1);
  }


  sendData(): any {
    const dataToSend = {...this.titleData};
    delete dataToSend.all;
    this.activeModal.close(dataToSend);
  }

  createLinkFields() {
    this.titleData.titleVirtual.push({
      title: '',
      link: null,
      status: 'Activo',
      orderId: this.titleData.titleVirtual.length + 1,
    });
  }


  deleteLinkField(i: number): any {
    if (this.titleData.titleVirtual.length > 1) {
      this.titleData.titleVirtual.splice(i, 1);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'No puedes eliminar el primer link!',
      });
    }
  }

  validateEmptyFields(): any {
    return !(!this.titleData.title || this.titleData.arr.filter(x => !x.title).length);
  }

  // checkExistingName(): any {
  //   const validators = [];
  //   this.titleData.all.forEach(item => {
  //     item.detail.forEach(child => {
  //       validators.push(child.title);
  //     });
  //   });
  //   const checkExistingName = (arr, val) => {
  //     return arr.some(arrVal => {
  //       return val.toLowerCase().trim() === arrVal.toLowerCase().trim();
  //     });
  //   };
  //   const valueToRemove = validators.indexOf(this.titleData.title);
  //   validators.splice(valueToRemove, 1);
  //   return checkExistingName(validators, this.titleData.title);
  // }
}
